import { TypedEmitter } from 'tiny-typed-emitter'

export type PerformanceStats = {
    appContextDispatchCt: number
    userContextDispatchCt: number
    roomContextDispatchCt: number
    collaboratePageRenderCt: number
    galleryVideoLayoutRecalcCt: number
}

interface PerfStatsEvents {
    changed: (data: PerformanceStats) => void
}

export class PerfStatsEmitterClass extends TypedEmitter<PerfStatsEvents> {
    state: PerformanceStats

    constructor() {
        super()
        this.state = {
            appContextDispatchCt: 0,
            userContextDispatchCt: 0,
            roomContextDispatchCt: 0,
            collaboratePageRenderCt: 0,
            galleryVideoLayoutRecalcCt: 0,
        }
    }

    inc(fieldName: keyof PerformanceStats) {
        this.state[fieldName]++
        this.emit('changed', { ...this.state })
    }

    reset() {
        this.state = {
            appContextDispatchCt: 0,
            userContextDispatchCt: 0,
            roomContextDispatchCt: 0,
            collaboratePageRenderCt: 0,
            galleryVideoLayoutRecalcCt: 0,
        }
        this.emit('changed', { ...this.state })
    }
}

export const PerfStatsEmitter = new PerfStatsEmitterClass()
